import React from 'react'

import style from './Parameter.module.scss'
import { render } from '~utils/rehype-render'

const Description = ({ 
  param 
}) => (
  <div  className={ style.description }>
    { render(param.descriptionAst) }
  </div>
)

export default Description